import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { constructionColumn } from "Constants/TableColumns";
import RemoteTable from "Components/RemoteTable/RemoteTable";
import { read } from "Helpers/LocalStorage";
import { getProjectBuildInfo } from "Stores/actions";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Checkbox,
  Chip,
  Grid,
} from "@material-ui/core";
import { CONSTRUCTION_RESULT } from "Stores/actionTypes";
import Translator from "Languages/Utility/Translator";
import MuiAutoComplete from "Components/MuiAutoComplete/MuiAutoComplete";
import { useSetState } from "Helpers/Hooks";
import MuiButton from "Components/MuiButton/MuiButton";
import ProjectService from "Services/http/endpoints/project/ProjectService";
import CustomerService from "Services/http/endpoints/customer/CustomerService";
import StatusHandler from "Helpers/StatusHandler";
import showNotify from "../../../../Helpers/Notify";
import { useTranslation } from "react-i18next";
import * as Icons from "react-bootstrap-icons";
import BackDropLoading from "Components/BackDropLoading/BackDropLoading";
import MuiPaper from "Components/MuiPaper/MuiPaper";
import { ExpandMore } from "@material-ui/icons";
import MuiIconButton from "Components/MuiIconButton/MuiIconButton";

function ConstructionTable({
  parentLoading,
  idProjects,
  tab,
  addProject,
  deleteProject,
}) {
  const { t } = useTranslation();
  const {
    constructionData,
    constructionPagination,
    constructionResult,
    selectedProject,
  } = useSelector((state) => ({
    selectedProject: state.project.selectedProject,
    constructionData: state.construction.constructionData,
    constructionPagination: state.construction.constructionPagination,
    constructionResult: state.construction.constructionResult,
  }));
  const dispatch = useDispatch();
  const [StypeU, setStypeU] = useState(null);
  const [UserC, setUserC] = useState(null);
  const [sizePerPage, setSizePerPage] = useState();
  const [loading, setLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState();
  const [total, setTotal] = useState(1);
  const [tblData, setTblData] = useState([]);
  const [showBox, setShowBox] = useState(false);
  const [alertShow, setAlertShow] = useState(false);
  const [expanded, setExpanded] = useState("");
  const [selectedProjects, setSelectedProjects] = useState([]);
  const [controls, setControls] = useSetState({
    users: {
      type: "select",
      selectItems: [],
      value: "",
    },
    customers: {
      type: "select",
      selectItems: [],
      value: "",
    },
    projects: {
      type: "select",
      selectItems: [],
      value: "",
    },
  });

  const handleChange = (panel) => (event, newExpanded) => {
    setExpanded(newExpanded ? panel : false);
  };

  // const expandRow = {
  //   renderer: (row) => (
  //     <div className="d-flex flex-column align-items-start ">
  //       <p className="normalTitle mt-2">
  //         <Translator id="unit_information" noSpan />
  //       </p>
  //       <ul>
  //         <li className="d-flex flex-row mt-2">
  //           <b className="mx-2">
  //             <Translator id="isProfile" noSpan />
  //           </b>
  //           <span className="mx-2">{row.GroupProfile}</span>
  //         </li>
  //         <li className="d-flex flex-row mt-2">
  //           <b className="mx-2">
  //             <Translator id="isFitting" noSpan />
  //           </b>
  //           <span className="mx-2">{row.Fitting}</span>
  //         </li>
  //         <li className="d-flex flex-row mt-2">
  //           <b className="mx-2">
  //             <Translator id="isGlass" noSpan />
  //           </b>
  //           <span className="mx-2">{row.Glass}</span>
  //         </li>
  //       </ul>
  //     </div>
  //   ),
  //   showExpandColumn: true,
  //   expandColumnPosition: "right",
  //   expandHeaderColumnRenderer: () => null,
  //   expandColumnRenderer: ({ expanded }) => {
  //     if (expanded) {
  //       return <ReactSVG src={minusIcon} />;
  //     }
  //     return <ReactSVG src={moreIcon} />;
  //   },
  // };

  useEffect(() => {
    if (constructionData) {
      const preData = constructionData;
      preData.map((item) => {
        item.dual = selectedProjects.length === 0 ? false : true;
      });
      setTblData(preData);
      setTotal(constructionPagination.Total);
      setCurrentPage(constructionPagination.Page);
      setSizePerPage(constructionPagination.Limit);
      if (constructionResult.CheckAll && preData.length !== 0) {
        let ListUnitId = constructionResult.ListUnitId;
        if (constructionPagination.Page === 1) {
          ListUnitId = preData.map((row) => {
            return { unitId: row.Id, ProjectId: row.IdProject };
          });
        } else {
          preData.map((row) => {
            ListUnitId.push({ unitId: row.Id, ProjectId: row.IdProject });
          });
        }
        dispatch({
          type: CONSTRUCTION_RESULT,
          constructionResult: { ...constructionResult, ListUnitId },
        });
      }
    }
  }, [constructionData, constructionPagination, constructionResult.CheckAll]);

  const selectRow = {
    mode: "checkbox",
    clickToSelect: true,
    selected: constructionResult.ListUnitId.map((i) => i.unitId),
    onSelect: (row, isSelect) => {
      let list = constructionResult.ListUnitId;
      if (isSelect) {
        list.push({ unitId: row.Id, ProjectId: row.IdProject });
      } else {
        list = list.filter((item) => item.unitId !== row.Id);
      }
      dispatch({
        type: CONSTRUCTION_RESULT,
        constructionResult: {
          ...constructionResult,
          ListUnitId: list,
          CheckAll: false,
        },
      });
    },
    onSelectAll: (isSelect, rows) => {
      dispatch({
        type: CONSTRUCTION_RESULT,
        constructionResult: {
          ...constructionResult,
          CheckAll: !constructionResult.CheckAll,
          ListUnitId: constructionResult.CheckAll
            ? []
            : constructionResult.ListUnitId,
        },
      });
    },
    classes: "selection-row",
    selectionHeaderRenderer: ({ indeterminate, ...rest }) => (
      <Checkbox
        className="selectRadio"
        // ref={(input) => {
        //   if (input) input.indeterminate = indeterminate;
        // }}
        {...rest}
        checked={constructionResult.CheckAll}
      />
    ),
    selectionRenderer: ({ checked, disabled }) => {
      return (
        <Checkbox
          className="selectRadio"
          color="default"
          checked={checked}
          disabled={disabled}
        />
      );
    },
  };

  useEffect(() => {
    (async () => {
      // if (tab === "optimize-profile" || tab === "optimize-galvanize") {
      if (tab === "optimize") {
        setShowBox(true);
        if (selectedProjects.length !== 0) setAlertShow(true);
        try {
          if ((StypeU === "1" || StypeU === "5") && UserC === "-") {
            const params = {
              Key: read("groupKey"),
              KeyUs: read("userKey"),
            };
            const responseUsers = await ProjectService.selectUserGroupCombo(
              params
            );
            let err = StatusHandler(responseUsers);
            if (!err.isFail) {
              const lists = responseUsers.data.Value;
              const items = lists.map((item) => {
                return {
                  ...item,
                  label: item.DisplayName,
                  value: item.Key,
                };
              });
              setControls({ users: { selectItems: items } });

              const paramsCustomer = {
                KeyGroup: read("groupKey"),
                KeyUser: read("userKey"),
                KeyRequestUser: items[0].value,
              };
              const responseCustomer = await CustomerService.getComboMoshtari(
                paramsCustomer
              );
              let err = StatusHandler(responseCustomer);
              if (!err.isFail) {
                const moshtariList = responseCustomer.data.Value;
                const items = moshtariList.map((m) => {
                  return {
                    ...m,
                    value: m.Id,
                    label: m.Name,
                  };
                });
                setControls({ customers: { selectItems: items } });
              }
            }
          } else {
            const params = {
              KeyGroup: read("groupKey"),
              KeyUser: read("userKey"),
            };
            const responseCustomer = await CustomerService.getComboMoshtari(
              params
            );
            let err = StatusHandler(responseCustomer);
            if (!err.isFail) {
              const moshtariList = responseCustomer.data.Value;
              const items = moshtariList.map((m) => {
                return {
                  ...m,
                  value: m.Id,
                  label: m.Name,
                };
              });
              setControls({ customers: { selectItems: items } });
            }
          }
        } catch (err) {}
      } else {
        setShowBox(false);
      }
    })();
  }, [tab]);

  useEffect(() => {
    setStypeU(read("StypeU"));
    setUserC(read("UserC"));
  }, []);

  const onTableChange = async (type, { page, sizePerPage }) => {
    if (type === "pagination") {
      try {
        setLoading(true);
        const params = {
          KeyGroup: read("groupKey"),
          KeyUser: read("userKey"),
          IdProjects: idProjects,
          IdProject: 0,
          Limit: sizePerPage,
          Page: page,
        };
        await dispatch(getProjectBuildInfo(params));
        setCurrentPage(page);
        setSizePerPage(sizePerPage);
        setLoading(false);
      } catch (e) {
        setLoading(false);
      }
    }
  };
  const autoCompleteHandler = async (e, value) => {
    const controlName = e.target.id.split("-")[0];
    setControls({ [controlName]: { value: value } });
    if (controlName === "customers") {
      try {
        let params = {
          KeyGroup: read("groupKey"),
          KeyUser: read("userKey"),
          IdCustomer: controls.customers.value.value,
        };
        if ((StypeU === "1" || StypeU === "5") && UserC === "-") {
          params = {
            KeyGroup: read("groupKey"),
            KeyUser: read("userKey"),
            KeyRequestUser: controls.users.value.value,
            IdCustomer: controls.customers.value.value,
          };
        }

        const response = await ProjectService.getAllProjectCustomerList(params);
        let err = StatusHandler(response);
        if (!err.isFail) {
          const projectList = response.data.Value;
          const items = projectList.map((m) => {
            return {
              ...m,
              value: m.Id,
              label: m.Name,
            };
          });
          setControls({ projects: { selectItems: items } });
        }
      } catch (err) {}
    }
    if (controlName === "users") {
      try {
        setLoading(true);
        const paramsCustomer = {
          KeyGroup: read("groupKey"),
          KeyUser: read("userKey"),
          KeyRequestUser: value.value,
        };
        const responseCustomer = await CustomerService.getComboMoshtari(
          paramsCustomer
        );
        let err = StatusHandler(responseCustomer);
        if (!err.isFail) {
          const moshtariList = responseCustomer.data.Value;
          const items = moshtariList.map((m) => {
            return {
              ...m,
              value: m.Id,
              label: m.Name,
            };
          });
          setControls({ customers: { selectItems: items } });
          setControls({ customers: { value: "" } });
          setControls({ projects: { value: "" } });
          setControls({ projects: { selectItems: [] } });
        }
        setLoading(false);
      } catch (e) {
        setLoading(false);
      }
    }
  };
  const onAddProjectToList = async () => {
    const selects = [...selectedProjects];
    if (
      !selects.some((item) => item.Id === controls.projects.value.value) &&
      controls.projects.value.value !== selectedProject.Id
    ) {
      selects.push(controls.projects.value);
      setSelectedProjects(selects);
      setAlertShow(true);
    } else {
      showNotify({ text: t("repetitiveProject"), customClass: "warning" });
    }
    setControls({ customers: { value: "" } });
    setControls({ projects: { value: "" } });
    setControls({ users: { value: "" } });
    addProject(controls.projects.value.value);
  };

  const onDeleteProjectToList = async (project) => {
    let selects = [...selectedProjects];
    selects = selects.filter((item) => item.Id !== project.Id);
    setSelectedProjects(selects);
    deleteProject(project.Id);
    selects.length !== 0 ? setAlertShow(true) : setAlertShow(false);
  };

  return (
    <>
      <BackDropLoading loading={loading} />
      {showBox && (
        <MuiPaper className="w-100 mb-3">
          <Accordion
            className="border-0 shadow-none"
            expanded={expanded === "Setting"}
            onChange={handleChange("Setting")}
          >
            <AccordionSummary expandIcon={<ExpandMore />}>
              <Icons.FolderPlus size={18} />
              <p>{t("add_project_to_list")}</p>
            </AccordionSummary>
            <AccordionDetails className="p-0">
              <Grid container spacing={2} className="px-3">
                {(StypeU === "1" || StypeU === "5") && UserC === "-" && (
                  <Grid item md={3} sm={6} xs={12}>
                    <MuiAutoComplete
                      autoSelect={true}
                      options={controls.users.selectItems}
                      label={<Translator id={"users"} />}
                      value={controls.users.value}
                      id={"users"}
                      onChange={autoCompleteHandler}
                    />
                  </Grid>
                )}
                <Grid item md={3} sm={6} xs={12}>
                  <MuiAutoComplete
                    autoSelect={true}
                    options={controls.customers.selectItems}
                    label={<Translator id={"customers"} />}
                    value={controls.customers.value}
                    id={"customers"}
                    onChange={autoCompleteHandler}
                  />
                </Grid>
                <Grid item md={3} sm={6} xs={12}>
                  <MuiAutoComplete
                    disabled={!controls.customers.value.value}
                    autoSelect={true}
                    options={controls.projects.selectItems}
                    label={<Translator id={"projects"} />}
                    value={controls.projects.value}
                    id={"projects"}
                    onChange={autoCompleteHandler}
                  />
                </Grid>
                <Grid item md={3} sm={6} xs={12} className="margin-top-button">
                  <MuiButton
                    loading={loading}
                    disabled={!controls.projects.value.value}
                    color="secondary"
                    title={<Translator id="ezafe_be_list" />}
                    innerIcon={<Icons.PlusLg />}
                    onClick={onAddProjectToList}
                    fullwidthOnSm
                  />
                </Grid>
                {selectedProjects.length !== 0 && (
                  <Grid
                    item
                    xs={12}
                    className="my-2 px-3 d-flex flex-row flex-wrap justify-content-start align-items-center g-2"
                    style={{
                      backgroundColor: "#f8f9fb",
                      borderRadius: "6px",
                    }}
                  >
                    <Icons.Folder size={20} color="#dfe0e7" />
                    {selectedProjects.map((item) => {
                      return (
                        <Chip
                          size="small"
                          className="project-name"
                          label={item.Name}
                          onDelete={() => onDeleteProjectToList(item)}
                        />
                      );
                    })}
                  </Grid>
                )}
              </Grid>
            </AccordionDetails>
          </Accordion>
        </MuiPaper>
      )}
      <MuiPaper className="w-100 mb-3">
        {(showBox && alertShow) && (
          <Grid item xs={12} className="info-alert-dialog warning mb-2">
            <Icons.ExclamationDiamond size={17} />
            <p className="normalTitle">{t("default_project_has_Another")}</p>
            <div className="info-alert-action">
              <MuiIconButton
                className="warning-fill"
                icon={<Icons.X />}
                title={t("close")}
                onClick={() => setAlertShow(false)}
              />
            </div>
          </Grid>
        )}
        <RemoteTable
          className="mt-2" //"fixHeight"
          keyField="Id"
          loading={loading || parentLoading}
          selectRow={selectRow}
          data={tblData}
          columns={constructionColumn}
          page={currentPage}
          sizePerPage={sizePerPage}
          totalSize={total}
          onTableChange={onTableChange}
          title={<Translator id={"listItems"} />}
          // expandRow={expandRow}
        />
      </MuiPaper>
    </>
  );
}

export default ConstructionTable;
